import { render } from "./timeago.vue?vue&type=template&id=3269671b"
import script from "./timeago.vue?vue&type=script&lang=js"
export * from "./timeago.vue?vue&type=script&lang=js"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__